module.exports = __webpack_public_path__ + "img/qvo-logo-color.f6f82de6.svg";